<div class="privacy-content" [innerHTML]="privacySettings"></div>
